import { InstrumentDefinition, InstrumentType } from '../types';
import { BANJO_DEFINITION } from './banjo';
import { BASS_DEFINITION } from './bass';
import { GUITAR_DEFINITION } from './guitar';
import { MANDOLIN_DEFINITION } from './mandolin';
import { UKULELE_DEFINITION } from './ukulele';
export const ALL_INSTRUMENTS: InstrumentDefinition[] = [
  GUITAR_DEFINITION,
  BASS_DEFINITION,
  UKULELE_DEFINITION,
  BANJO_DEFINITION,
  MANDOLIN_DEFINITION,
];

function createInitialRecord(): Record<InstrumentType, InstrumentDefinition> {
  const record: Record<InstrumentType, InstrumentDefinition> = {
    Guitar: GUITAR_DEFINITION,
    Bass: BASS_DEFINITION,
    Ukulele: UKULELE_DEFINITION,
    Mandolin: MANDOLIN_DEFINITION,
    Banjo: BANJO_DEFINITION,
  };
  return record;
}

export const INSTRUMENTS_BY_TYPE: Record<InstrumentType, InstrumentDefinition> =
  ALL_INSTRUMENTS.reduce<Record<InstrumentType, InstrumentDefinition>>((acc, instrument) => {
    acc[instrument.type] = instrument;
    return acc;
  }, createInitialRecord());
